<template>
  <div>
    <PrimaryBox>
      <template slot="title">天气</template>
      <div class="primaryBox">
        <div class="locationBox">
          <Select class="select_county" v-model="currentCounty" @on-change="getWeatherMessage" prefix="ios-pin">
            <Option v-for="(item,index) in countyList" :key="index" :value="item.code">{{ item.name }}</Option>
          </Select>
          <el-button icon="el-icon-cloudy" type="text" size="small" @click="showCloud">云图</el-button>
        </div>
        <div class="weatherOutBox">
          <div class="weatherBox"
               v-for="(item,index) in weatherList"
               :key="index"
               id="weatherBox"
          >
            <p class="times">{{ $moment(item.fxDate).format('MM-DD') }}</p>
            <i :class="'qi-'+item.iconDay+'-fill'" class="weatherIcon"></i>
            <p class="weather">{{ item.textDay }}</p>
            <p class="temperature">{{ item.tempMin + '°' + '-' + item.tempMax + '°' }}</p>
            <p class="WindDirection" v-if="index===0">
              <img alt="" src="./../../images/shidu2.png" class="img"/>{{ item.humidity }}
            </p>
            <p class="humidity" v-if="index===0">
              <img alt="" src="./../../images/fengxiang.png" class="img"/>{{ item.windDirDay }}
            </p>
          </div>
        </div>
      </div>
    </PrimaryBox>

    <Modal
        :mask="false"
        v-model="modal"
        width="50"
        title="气象云图"
        footer-hide
        :styles="{top: '8%'}">
      <el-button type="text" slot="close" icon="el-icon-close" @click="beforeClose">
      </el-button>
<!--      <cloud-map></cloud-map>-->
        <iframe id="cloudIframe"
                width="100%"
                height="100%"
                frameborder="0"
                scrolling="no"
                src="cloud/cloud.html">
        </iframe>
    </Modal>
  </div>
</template>

<script>
import PrimaryBox from "../PrimaryBox/PrimaryBox.vue"
import axios from "axios";

export default {
  components: {
    PrimaryBox
  },
  name: "weather",
  data() {
    return {
      modal: false,
      cloudUrl: 'https://qlfy.sdmsc.net/web/products/sates/?StationID=54714',
      cloudContent: null,
      currentCounty: '101120401',
      weatherBoxActive: 0,
      weatherBoxNotActive: '',
      weatherList: [],
      flag: true,
      countyList: [
        { name: '德州', code: '101120401' },
        { name: '武城', code: '101120402' },
        { name: '临邑', code: '101120403' },
        { name: '陵县', code: '101120404' },
        { name: '齐河', code: '101120405' },
        { name: '乐陵', code: '101120406' },
        { name: '庆云', code: '101120407' },
        { name: '平原', code: '101120408' },
        { name: '宁津', code: '101120409' },
        { name: '夏津', code: '101120410' },
        { name: '禹城', code: '101120411' }
      ]
    }
  },
  mounted() {
    this.getWeatherMessage()
  },
  methods: {
    showCloud() {
      this.modal = true
      let iframeDom = document.getElementById('cloudIframe')
      let content = iframeDom.contentWindow || iframeDom.contentDocument
      let doc = content.document
      let body = doc.body
      this.$http.get('/api/getCloudChart').then(res => {
        // this.cloudContent = res.data
        let html = res.data
        let htmlstr = html.toString()
        let sIndex = htmlstr.indexOf('<form')
        let eIndex = htmlstr.indexOf('</body')
        let bodystr = htmlstr.slice(sIndex, eIndex)
        var div = doc.createElement('div')
        div.id = 'iframeForm'
        div.innerHTML = bodystr
        body.appendChild(div)
      })
    },
    beforeClose(){
      this.modal = false
      // 移除iframe中的内容
      let iframeDom = document.getElementById('cloudIframe')
      let content = iframeDom.contentWindow || iframeDom.contentDocument
      let doc = content.document
      doc.getElementById('iframeForm').remove()
    },
    transitionend(res) {
      if (res.elapsedTime === 0.3) {
        this.flag = true
      }
    },
    weatherBoxIsActive(index) {
      this.weatherBoxActive = index
    },
    weatherBoxIsNotActive(index) {
      this.weatherBoxNotActive = index
    },
    getWeatherMessage() {
      axios.get(`https://devapi.qweather.com/v7/weather/7d?location=${this.currentCounty}&key=9b3a1fa0cd9e4ae793a8e9166f783f5a`).then(res => {
        if (res.data.code === '200') {
          this.weatherList = res.data.daily
          this.weatherList.pop()
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
@import 'weather.less';
</style>
